export default {"src":"/_next/static/media/WhoWeAre_033A.f3ce9c17.JPG","height":700,"width":1920};